The response from the `updateCandidateProcessHistoryItem` mutation.
